module.exports = __webpack_public_path__ + "static/media/game_white.59b4f105.svg";